<template>
  <h1
    v-if="!showMessage"
    class="heading-md p-4 text-center"
    v-text="'Forgot Password'"
  />

  <ForgotPasswordMessage v-if="showMessage" />

  <ForgotPasswordForm
    v-else
    @show-message="showMessage = true"
  />
</template>

<script lang="ts" setup>
import { ref } from 'vue'

import ForgotPasswordForm from '@js/components/auth/forgot-password/ForgotPasswordForm.vue'
import ForgotPasswordMessage from '@js/components/auth/forgot-password/ForgotPasswordMessage.vue'

defineOptions({
  name: 'AppForgotPasswordContainer',
})

const showMessage = ref(false)
</script>
